import { motion } from "framer-motion";

export function RobotOrb({ className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
      className={`pointer-events-none relative select-none ${className}`}
      aria-hidden="true"
    >
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 26, repeat: Infinity, ease: "linear" }}
        className="absolute inset-0 rounded-full border border-primary/25"
      />
      <motion.div
        animate={{ rotate: -360 }}
        transition={{ duration: 18, repeat: Infinity, ease: "linear" }}
        className="absolute inset-[12%] rounded-full border border-dashed border-primary/20"
      />
      <motion.div
        animate={{ scale: [1, 1.08, 1], opacity: [0.35, 0.6, 0.35] }}
        transition={{ duration: 4, repeat: Infinity }}
        className="absolute inset-[6%] rounded-full blur-2xl"
        style={{ background: "var(--gradient-gold)", opacity: 0.25 }}
      />

      <motion.svg
        viewBox="0 0 200 200"
        className="relative h-full w-full"
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      >
        <defs>
          <linearGradient id="robo-gold" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="var(--gold-deep)" />
            <stop offset="50%" stopColor="var(--gold)" />
            <stop offset="100%" stopColor="var(--gold-soft)" />
          </linearGradient>
        </defs>

        <line x1="100" y1="30" x2="100" y2="52" stroke="url(#robo-gold)" strokeWidth="2" />
        <motion.circle
          cx="100"
          cy="26"
          r="5"
          fill="url(#robo-gold)"
          animate={{ opacity: [1, 0.3, 1] }}
          transition={{ duration: 1.6, repeat: Infinity }}
        />

        <rect
          x="46"
          y="52"
          width="108"
          height="92"
          rx="26"
          fill="var(--surface)"
          stroke="url(#robo-gold)"
          strokeWidth="1.6"
          opacity="0.95"
        />
        <rect x="60" y="72" width="80" height="42" rx="16" fill="var(--background)" opacity="0.85" />
        <motion.rect
          x="60"
          y="72"
          width="80"
          height="8"
          rx="4"
          fill="url(#robo-gold)"
          opacity="0.35"
          animate={{ y: [72, 106, 72] }}
          transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.g animate={{ opacity: [1, 1, 0.15, 1] }} transition={{ duration: 5, repeat: Infinity }}>
          <circle cx="82" cy="93" r="7" fill="url(#robo-gold)" />
          <circle cx="118" cy="93" r="7" fill="url(#robo-gold)" />
        </motion.g>
        {[0, 1, 2, 3, 4].map((i) => (
          <motion.rect
            key={i}
            x={78 + i * 10}
            y="118"
            width="5"
            height="14"
            rx="2"
            fill="url(#robo-gold)"
            style={{ originY: 1, transformBox: "fill-box" }}
            animate={{ scaleY: [0.3, 0.9, 0.45, 1, 0.3] }}
            transition={{ duration: 1.8 + i * 0.2, repeat: Infinity, ease: "easeInOut" }}
          />
        ))}
        <rect x="36" y="82" width="8" height="26" rx="4" fill="url(#robo-gold)" opacity="0.7" />
        <rect x="156" y="82" width="8" height="26" rx="4" fill="url(#robo-gold)" opacity="0.7" />
        <rect x="88" y="144" width="24" height="14" rx="6" fill="url(#robo-gold)" opacity="0.5" />
        <ellipse className="robot-shadow" cx="100" cy="166" rx="46" ry="9" fill="url(#robo-gold)" />
      </motion.svg>
    </motion.div>
  );
}
